import { useState, type ReactElement } from 'react';
import { Link } from 'react-router';
import { CHEMINS } from '../routes.js';
import { creerClient, type ResultatCreationClient } from '../plateforme.js';
import { EchecApi } from '../api.js';

/**
 * CREER UN CLIENT, DEPUIS LE PRODUIT [contrats 28-BS, 28-BT, 28-BU].
 *
 * NOM COMPLET TOUJOURS VISIBLE, ET C EST UN CHOIX : savoir a l avance si un
 * courriel est connu exigerait une route de sondage, donc un ORACLE sur les
 * comptes d Anelya. Le champ est donc optionnel -- ignore si le compte
 * existe, employe sinon.
 *
 * LE SECRET NE VIT QU EN MEMOIRE [28-BT]. Aucun stockage, aucune relecture :
 * un rechargement le perd, et c est ainsi que le serveur le promet.
 */
export function NouveauClient(): ReactElement {
  const [nom, setNom] = useState('');
  const [code, setCode] = useState('');
  const [courriel, setCourriel] = useState('');
  const [nomProprietaire, setNomProprietaire] = useState('');
  const [envoi, setEnvoi] = useState(false);
  const [erreur, setErreur] = useState<string | undefined>(undefined);
  const [fait, setFait] = useState<ResultatCreationClient | undefined>(undefined);

  const pret = nom.trim() !== '' && code.trim() !== '' && courriel.trim() !== '';

  const surCreer = async (): Promise<void> => {
    setEnvoi(true); setErreur(undefined);
    try {
      const r = await creerClient({
        code: code.trim(), nom: nom.trim(), courrielProprietaire: courriel.trim(),
        nomProprietaire: nomProprietaire.trim() === '' ? undefined : nomProprietaire.trim() });
      setFait(r);
    } catch (e) {
      const c = e instanceof EchecApi ? e.detail.code : '';
      setErreur(c === 'code_locataire_deja_pris'
        ? 'Ce code est deja utilise. Choisissez-en un autre.'
        : c === 'role_plateforme_requis'
          ? 'Ce geste exige un role plateforme.'
          : e instanceof Error ? e.message : 'Echec inattendu.');
    } finally { setEnvoi(false); }
  };

  if (fait !== undefined) {
    return (
      <section>
        <h1>Client cree</h1>
        <p>{fait.locataire.nom} — code {fait.locataire.code}</p>
        {fait.proprietaire === 'cree' ? (
          <div>
            <h2>Mot de passe initial</h2>
            <p><code>{fait.accesInitial.secret}</code></p>
            <p><strong>Affiche une seule fois.</strong> Copiez-le maintenant et
              transmettez-le par un canal sur. Anelya n en garde qu un derive.</p>
          </div>
        ) : (
          <p>Le proprietaire possedait deja un compte : son mot de passe est
            inchange.</p>
        )}
        <p><Link to={CHEMINS.plateforme}>Retour a l administration</Link></p>
        <p><Link to={CHEMINS.espaces}>&larr; Mes espaces</Link></p>
      </section>
    );
  }

  return (
    <section>
      <p><Link to={CHEMINS.plateforme}>&larr; Administration</Link></p>
      <h1>Nouveau client</h1>
      <label>Nom du client
        <input value={nom} onChange={(e) => setNom(e.target.value)}
          placeholder="UP d Amay" /></label>
      <p className="discret">Le nom lisible, tel qu il s affichera partout.
        Accents, espaces et majuscules sont permis.</p>
      <label>Code
        <input value={code} onChange={(e) => setCode(e.target.value)}
          placeholder="up-amay" /></label>
      <p className="discret">L identifiant court qui apparaitra dans l adresse
        du navigateur : /espaces/up-amay. Minuscules, chiffres et tirets
        uniquement, sans espace ni accent. Il ne pourra plus changer.</p>
      <label>Courriel du proprietaire
        <input type="email" value={courriel}
          onChange={(e) => setCourriel(e.target.value)} /></label>
      <p className="discret">La personne qui administrera ce client. Si ce
        courriel n a pas encore de compte, il en sera cree un et son mot de
        passe s affichera UNE seule fois.</p>
      <label>Nom complet du proprietaire
        <input value={nomProprietaire}
          onChange={(e) => setNomProprietaire(e.target.value)} /></label>
      <p className="discret">Employe seulement si le compte doit etre cree ;
        ignore si le courriel en a deja un.</p>
      {erreur !== undefined ? <p role="alert">{erreur}</p> : null}
      <button type="button" disabled={!pret || envoi} onClick={() => void surCreer()}>
        {envoi ? 'Creation...' : 'Creer le client'}
      </button>
      <Link to={CHEMINS.plateforme}>Annuler</Link>
    </section>
  );
}
